const pageTitles = {
  "/dashboard": "Overview",
  "/management": "Dashboard / User Management",
  "/quotation": "Dashboard / Quotation",
  "/invoice": "Dashboard / Invoice",
  "/setting": "Dashboard / Setting",
};

export default pageTitles;
